import { API } from "@/app/api";
import {
  IResponseWithStatus,
  IUserCreate,
  IUserLogin,
  IUserLoginPayload,
  IUserSignUpPayload,
} from "@/data/api/auth-data";
import {
  getResponseStatus,
  normalizeErrorStatus,
  postApi,
} from "./post-api";

export async function logIn(
  payload: IUserLoginPayload,
  successCallback: (sessionId: string) => void,
  errorCallback: (status: string) => void
) {
  // fetch(API.Auth.userLogin, {
  //   method: "POST",
  //   body: JSON.stringify(payload),
  // })
  await postApi<IUserLogin>(API.Auth.userLogin, payload)
    .then((response) => {
      if (response && response.sessionid) {
        successCallback(response.sessionid);
      } else {
        errorCallback(getResponseStatus(response));
      }
    })
    .catch((reason) => {
      errorCallback(normalizeErrorStatus(reason));
    });
}

export async function signUp(
  payload: IUserSignUpPayload,
  successCallback: () => void,
  errorCallback: (status: string) => void
) {
  // fetch(API.Auth.userCreate, {
  //   method: "POST",
  //   body: JSON.stringify(payload),
  // })
  await postApi<IUserCreate>(API.Auth.userCreate, payload)
    .then((response) => {
      if (response && response.status == API.Status.Success) {
        successCallback();
      } else {
        errorCallback(getResponseStatus(response));
      }
    })
    .catch((reason) => {
      errorCallback(normalizeErrorStatus(reason));
    });
}

export async function confirmAccountActivation(
  token: string,
  successCallback: () => void,
  errorCallback: (status: string) => void
) {
  // fetch(API.User.Action, {
  //   method: "POST",
  //   body: JSON.stringify({ actionId: token }),
  // })
  await postApi<IResponseWithStatus>(API.User.Action, { actionId: token })
    .then((response) => {
      if (response && response.status == API.Status.Success) {
        successCallback();
      } else {
        errorCallback(getResponseStatus(response));
      }
    })
    .catch((reason) => {
      errorCallback(normalizeErrorStatus(reason));
    });
}

export async function changePasswordInitiate(
  login: string,
  successCallback: () => void,
  errorCallback: (status: string) => void
) {
  // fetch(API.User.ChangePassword, {
  //   method: "POST",
  //   body: JSON.stringify({ login: login }),
  // })
  await postApi<IResponseWithStatus>(API.User.ChangePassword, { login: login })
    .then((response) => {
      if (response && response.status == API.Status.Success) {
        successCallback();
      } else {
        errorCallback(getResponseStatus(response));
      }
    })
    .catch((reason) => {
      errorCallback(normalizeErrorStatus(reason));
    });
}

export async function sendNewPassword(
  pwd: string,
  actionId: string,
  successCallback: () => void,
  errorCallback: (status: string) => void
) {
  // fetch(API.User.Action, {
  //   method: "POST",
  //   body: JSON.stringify({ actionId: actionId, newPassword: pwd }),
  // })
  await postApi<IResponseWithStatus>(API.User.Action, {
    actionId: actionId,
    newPassword: pwd,
  })
    .then((response) => {
      if (response && response.status == API.Status.Success) {
        successCallback();
      } else {
        errorCallback(getResponseStatus(response));
      }
    })
    .catch((reason) => {
      errorCallback(normalizeErrorStatus(reason));
    });
}
